import {SECCIONES} from "../Constantes";
import {scrolearAComponente} from "./scrolearAComponente";
import {useNavigate} from "react-router";

export const useIrRuta = () => {
    const navigate = useNavigate()

    const ir = (secc) => {

        switch (secc) {
            case SECCIONES[0]:
                navigate('/'+SECCIONES[0]);

                break
            case SECCIONES[1]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente(SECCIONES[1])
                }, 500)
                break
            case SECCIONES[2]:
                navigate(SECCIONES[2])
                break
        }
    }

    return {
        ir
    }


}